module.exports = ['white', 'beige']